/*
* Created on Nov 01, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import Cookies from "js-cookie";
import {useRegion} from "../context/RegionContext";

const useEnableCookies = () => {
    const {region} = useRegion();

    const loadMautic = () => {
        (function(w,d,t,u,n,a,m){w['MauticTrackingObject']=n;
            // eslint-disable-next-line no-unused-expressions
        w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)},a=d.createElement(t),
        m=d.getElementsByTagName(t)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://event.qnap.com/mtc.js','mt');

        // eslint-disable-next-line no-undef
        mt('send', 'pageview')

        // (function (w, d, t, u, n, a, m) {
        //     w['MauticTrackingObject'] = n;
        //     w[n] = w[n] || function () {
        //         (w[n].q = w[n].q || []).push(arguments)
        //     };
        //     a = d.createElement(t);
        //     m = d.getElementsByTagName(t)[0];
        //     a.async = 1;
        //     a.src = u;
        //     m.parentNode.insertBefore(a, m)
        // })(window, document, 'script', 'https://event.qnap.com/mtc.js', 'mt');
    }

    const load_analytics_cookies= (is_enable) => {
        // Hotjar/GTM were stripped (unmaintained here, and content blockers
        // rejected the hotjar script anyway) - enabling analytics loads
        // nothing now. The opt-out branch still purges cookies that earlier
        // visits (or other qnap.com properties) may have set.
        if (!is_enable) {
            const ga_mid = window._env_.REACT_APP_GOOGLE_GA_MEASUREMENT_ID.split('-')[1];
            const hjid = window._env_.REACT_APP_HJID;
            const domain = region === 'CHINA' ? '.qnap.com.cn' : '.qnap.com';
            const path = "/"
            console.log(Cookies.get())
            Cookies.remove('_hjid', {path, domain});
            Cookies.remove('_hjFirstSeen', {path, domain});
            Cookies.remove('_hjIncludedInSessionSample', {path, domain});
            Cookies.remove(`_hjSession_${hjid}`, {path, domain});
            Cookies.remove(`_hjSessionUser_${hjid}`, {path, domain});
            Cookies.remove('_ga', {path, domain});
            Cookies.remove(`_ga_${ga_mid}`, {path, domain});

            Cookies.remove('_hjid');
            Cookies.remove('_hjFirstSeen');
            Cookies.remove('_hjIncludedInSessionSample');
            Cookies.remove(`_hjSession_${hjid}`);
            Cookies.remove(`_hjSessionUser_${hjid}`);
            Cookies.remove('_ga');
            Cookies.remove(`_ga_${ga_mid}`);

            Cookies.remove('mautic_session_id');
            Cookies.remove('mautic_device_id');
            Cookies.remove('mtc_sid');
            Cookies.remove('mtc_id');
            Cookies.remove('8204dbe3cbc311fa1f28abdb0174911a', {path: '/', domain: 'event.qnap.com'})
            console.log('unload cookies');
        }
    }

    const load_functional_cookies = (is_fc_enable) => {
        if (!is_fc_enable) {
            Cookies.remove('region_warning');
        }
    }

    const setFCSetting = (value) => {
        load_functional_cookies(value);
    }

    const setACSetting = (value) => {
        load_analytics_cookies(value);
    }

    return {setACSetting, setFCSetting};
}

export default useEnableCookies;